import { css } from '@emotion/react'
import { ExternalStyles, Text, Theme, useTheme } from 'bold-ui'
import { formatDate } from 'util/date/formatDate'
import { humanizeAge } from 'util/date/humanize-age'
import { isObjectDeepEmpty } from 'util/object'
import { formatNomeProfissional } from 'view/profissional/utils/utils-profissional'

import { MChatAnteriorFooterInfoModel } from '../model-mchat'

interface MChatFooterInfoProps {
  info: MChatAnteriorFooterInfoModel
  style?: ExternalStyles
  cidadaoDataNascimento: LocalDate
}

export function MChatFooterInfo(props: MChatFooterInfoProps) {
  const { info, style, cidadaoDataNascimento } = props

  const theme = useTheme()
  const styles = createStyles(theme)

  if (isObjectDeepEmpty(info)) return null

  const {
    lotacao: { profissional, cbo },
    dataResultado,
  } = info

  const humanizedAge = humanizeAge(cidadaoDataNascimento, dataResultado)
  const avaliadoPorText = `${formatNomeProfissional(profissional)} - ${cbo.nome.titleCase()} em ${formatDate(
    dataResultado
  )}`

  return (
    <Text style={[styles.text, style]}>
      <strong>Avaliado por: </strong>
      {avaliadoPorText}
      {' | '}
      <strong>Idade da criança na avaliação: </strong>
      {humanizedAge}
    </Text>
  )
}

const createStyles = (theme: Theme) => ({
  text: css`
    color: ${theme.pallete.gray.c20};
  `,
})
